module.exports = require("clone");